import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from 'app/utils/providerHOC/providerHOC';
import store from '../headerStore';
import CSABannerApp from './csaBannerApp';

const CSABannerRoot = providerHOC(store)(CSABannerApp);
createRoot(document.getElementById('csa-banner')).render(<CSABannerRoot />);
